import intlTelInput from 'intl-tel-input';
import flatpickr from 'flatpickr';

/**
 * Create forms dynamically.
 * 
 * @param fields         An array with field objects
 * @param action         The POST route where axio should push data
 * @param wrapperTarget  The selector
 * @param excludeFields  When provided, it will exclude fields from rendering
 */
function createDynamicForm(fields = [], action, wrapperTarget = '', excludeFields, extraFields) {
    let wrapper = document.querySelector(wrapperTarget);
    // Create the form element even if we don't need it.
    // Since data is submitted via axios. This is just a fancy
    // way to make bots go crazy while trying to find the submit button or inputs
    let submitableForm = document.createElement('form');

    // Check if the form should render extra fields.
    // For ordering extra fields once is merged, you can pass 'order' key
    if( extraFields ) {

    }

    // count each iteration, so we can easily reorder the form fields
    // in case there are extra fields to be added on stack
    let fieldCounter = 0;

    fields.forEach(function(f) {

        // Check if the current field should be excluded from rendering
        if( excludeFields && excludeFields.includes(f.name) )
            return;

        // rendering fields in columns
        if( ( Object.keys(f)[0] === 'column') ) {
            let count = 1;
            f.column.forEach(function(cf) {
                makeField(cf, submitableForm, true, count++, wrapperTarget);
            })
            count = 1;
        } else {
            makeField(f, submitableForm, false, null, wrapperTarget);
        }
    });

    // Create the submit form
    let submit = document.createElement('button');
    submit.textContent = 'Send your message';
    submit.classList.add('btn-primary', 'rounded', 'tk-lora')
    
    // Append the submit form
    submitableForm.appendChild(submit);
    
    // Append the form to the wrapper target
    wrapper.appendChild(submitableForm);

    // Render with date calednar
    flatpickr('#check-in-out-dates', {
        minDate: new Date(),
        mode: 'range',
        dateFormat: 'Y-m-d',
    });

    let previousAppMessager = document.querySelector('div[form-messager]');
    if( previousAppMessager )
        previousAppMessager.remove();

    let formAppMessage = document.createElement('div');
        formAppMessage.setAttribute('form-messager', '');

    submitableForm.addEventListener('submit', function(form){
        form.preventDefault();

        let formBtn = document.querySelector(wrapperTarget + ' button');
            formBtn.setAttribute('disabled', 'disabled');
            formBtn.textContent = 'Sending...';
            formBtn.style.opacity = '.6';
        
        let formfields = form.currentTarget.elements;
        let dataBagCollection = {};        
        
        for (var i = 0; i < formfields.length; i++) {
            let k = formfields[i].name,
                v = formfields[i].value;
            dataBagCollection[k] = v;
        }

        axios.post(action, dataBagCollection).then(function (response) {
            
            // remove previously added field-error class
            for (let el_field in dataBagCollection) {
                if( el_field ) {
                    let elField = document.querySelector( wrapperTarget + ' input[name=' + el_field +']');
                    if( elField )
                        elField.classList.remove('field-error');
                }
            }

            if( response.data.status === 'error' ) {

                // In case there are fields with errors,
                // parse each field key and attach the error class to each of them.
                if( response.data.fields ) {
                    for(let err_field in response.data.fields) {
                        let findErrField = document.querySelector( wrapperTarget + ' input[name=' + err_field +']');
                        findErrField.classList.add('field-error')
                    }
                // If the error is not related to fields, then print a generic error message
                } else {
                    formAppMessage.innerHTML = '<p class="error fs-medium">' + response.data.message + '</p>';
                    wrapper.parentNode.insertBefore(formAppMessage, wrapper);
                    // cleanup the form and make the user to fill again.
                    wrapper.innerHTML = '';
                }

            formBtn.setAttribute('disabled', '');
            formBtn.textContent = 'Send your message';
            formBtn.style.opacity = '1';

            } else if( response.data.status === 'success' ) {
                // print the success message
                formAppMessage.innerHTML = '<p class="success fs-medium">' + response.data.message + '</p>';
                wrapper.parentNode.insertBefore(formAppMessage, wrapper);
                // cleanup form and prevent user to send the form again.
                wrapper.innerHTML = '';
            }

        }).catch(function (error) {
            // console.log(error); silent catch
        });
    });

}

/**
 * Create the field and append to its parent
 * @param  {[type]} f       [description]
 * @param  {[type]} wrapper [description]
 * @return {[type]}         [description]
 */
let previousColElement;
function makeField(f, wrapper, asColumn = false, colCount, wrapperTarget)
{
    let fieldType = f.field.type;
    let fieldElement = document.createElement(fieldType);
    
    let fieldColWrapper = document.createElement('div');
    let fieldWrapper = document.createElement('div');
    fieldWrapper.setAttribute('class', 'row');

    if( asColumn ) {
        fieldColWrapper.setAttribute('class', 'col-lg-6');    
    } else {
        fieldColWrapper.setAttribute('class', 'col-lg-12');
    }
    
    // Set field name and CSS class
    fieldElement.setAttribute('name', f.name);
    fieldElement.setAttribute('class', f.class);
    
    // Set field type
    if( fieldType === 'input' )
        fieldElement.setAttribute('type', f.field.field_type);

    // Set CSS ID
    if( f.id )
        fieldElement.setAttribute('id', f.id);

    // Attach the placeholder, if any
    if( f.placeholder )
        fieldElement.setAttribute('placeholder', f.placeholder);

    // Set field as required
    if( f.required === true )
        fieldElement.setAttribute('required', 'required');

    // Render with label
    if( f.label ) {
        let label = document.createElement('label');
        label.textContent = f.label;
        fieldColWrapper.appendChild(label);
    }

    if( f.field.min ) {
        fieldElement.setAttribute('min', f.field.min);
    }

    if( asColumn ) {
        // If is a hidden field, do not wrap in row or col divs
        if( f.field.field_type === 'hidden' ) {
            fieldWrapper = fieldElement;
        } else {
            if( colCount === 1 ) {
                // append the field to its col 
                fieldColWrapper.appendChild(fieldElement);
                // append the col div to row div
                fieldWrapper.appendChild(fieldColWrapper);
                // set current field row wrapper for next field that comes.
                previousColElement = fieldWrapper;

            } else if( colCount === 2 ) {
                fieldWrapper.style.display = 'none';
                // append the field to its col
                fieldColWrapper.appendChild(fieldElement);
                // append the col to the previous row
                previousColElement.appendChild(fieldColWrapper);
                previousColElement = '';
            }
        }
    } else {
        // append the field to col div
        fieldColWrapper.appendChild(fieldElement);
        // append the col div to row div
        fieldWrapper.appendChild(fieldColWrapper);
    }

    wrapper.appendChild(fieldWrapper);

    // In case field requires extra features,
    // will attach now, after rendering
    if( f.field.init ) {
        
        // Transform current field to a phone collector
        if( f.field.init === 'phone' ) {
            let intl = intlTelInput(fieldElement);

                function watchPhoneField(intl, wrapperTarget, fieldElement)
                {
                    let phnumber = document.querySelector(wrapperTarget + ' input[name="full_phone_number"]');
                    if( fieldElement.value ) {
                        let country = intl.getSelectedCountryData();
                        phnumber.value = JSON.stringify({
                            dial_code: country.dialCode,
                            country: country.name,
                            phone_number: fieldElement.value
                        })
                    }
                }
                
                fieldElement.addEventListener('blur', function(){
                    watchPhoneField(intl, wrapperTarget, fieldElement)
                })

                fieldElement.addEventListener('countrychange', function(){
                    watchPhoneField(intl, wrapperTarget, fieldElement)
                })

        } else if( f.field.init === 'url' ) {
            fieldElement.value = window.location.href;
        }
    }
}

export default createDynamicForm;